import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'split-loading-placeholder',
  templateUrl: './split-loading-placeholder.component.html',
  styleUrls: ['./split-loading-placeholder.component.scss']
})
export class SplitLoadingPlaceholderComponent implements OnChanges {
  @Input() count = 3;

  items: number[] = [];

  ngOnChanges(): void {
    this.items = Array.from({ length: this.count }, (_, i) => i);
  }
}
